import { useState } from "react";

/**
 * 文件管理相关状态 Hook
 * 包含文件列表、活动文件、文件内容等状态
 */
const useFileManagementState = () => {
  const [files, setFiles] = useState({});
  const [activeFile, setActiveFile] = useState(null);
  const [fileNameCounts, setFileNameCounts] = useState({});
  const [selectedFileLines, setSelectedFileLines] = useState({});
  const [activeFileContent, setActiveFileContent] = useState(null);
  const [fileFirstEntryMap, setFileFirstEntryMap] = useState(new Map());
  const [fileContentExpanded, setFileContentExpanded] = useState(true);
  const [panelWidth, setPanelWidth] = useState(600); // 文件面板初始展开宽度

  // 重置文件管理状态
  const resetFileManagementState = () => {
    setFiles({});
    setActiveFile(null);
    setFileNameCounts({});
    setSelectedFileLines({});
    setActiveFileContent(null);
    setFileFirstEntryMap(new Map());
    setFileContentExpanded(true);
    setPanelWidth(600);
  };

  return {
    files,
    setFiles,
    activeFile,
    setActiveFile,
    fileNameCounts,
    setFileNameCounts,
    selectedFileLines,
    setSelectedFileLines,
    activeFileContent,
    setActiveFileContent,
    fileFirstEntryMap,
    setFileFirstEntryMap,
    fileContentExpanded,
    setFileContentExpanded,
    panelWidth,
    setPanelWidth,
    resetFileManagementState,
  };
};

export default useFileManagementState;
